<template>
  <div id="legend" v-bind:style="{ left: `${left}px`}">
    <div v-for="d in dataTypes" :key="d.name">
      <div
        class="circle"
        v-bind:style="{ backgroundColor: d.color, border: `1.5px solid ${d.outline}` }"
      />
      <span>{{d.name}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Legend',
  props: ['dataTypes', 'left'],
}
</script>
<style>
#legend {
  position: absolute;
  top: 52vh;
  padding: 0.5rem;
  z-index: 10;
}
#legend > div {
  display: flex;
  align-items: flex-end;
  font-size: 14.75px;
  color: var(--grey-text);
  margin-bottom: 12px;
}
#legend .circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 12px;
}
</style>
